import { List } from '@dixa/lib-shared-habla';
import classNames from 'classnames';

import type { SettingsProductTeaserFeature } from '../../settingsProductTeaser';
import { FeatureCard } from '../featureCard';

import styles from './productTeaserFeaturesGrid.module.scss';

export type ProductTeaserFeatureColumns = 2 | 3 | 4;

type ProductTeaserFeaturesGridProps = {
  readonly features: readonly SettingsProductTeaserFeature[];
  readonly columns?: ProductTeaserFeatureColumns;
  readonly className?: string;
};

const columnsClassName: Record<
  ProductTeaserFeatureColumns,
  string | undefined
> = {
  2: styles.featuresListColumns2,
  3: styles.featuresListColumns3,
  4: styles.featuresListColumns4,
};

export const ProductTeaserFeaturesGrid = ({
  features,
  columns = 2,
  className,
}: ProductTeaserFeaturesGridProps): JSX.Element => {
  return (
    <List
      className={classNames(
        styles.featuresList,
        columnsClassName[columns],
        className,
      )}
    >
      {features.map((feature) => {
        const learnMoreLink = feature.learnMoreLink ?? feature.learnMoreUrl;

        return (
          <List.Item
            key={feature.title}
            variant="dense"
            withHoverEffect={false}
            className={styles.featureListItem}
          >
            <FeatureCard
              title={feature.title}
              description={feature.description}
              icon={feature.icon}
              learnMoreLink={learnMoreLink}
              onLearnMoreClick={feature.onLearnMoreClick}
            />
          </List.Item>
        );
      })}
    </List>
  );
};
